import { useEffect, useCallback } from 'react';
import { selectors, getAll, addItem, updateItem, deleteItem } from '../../../redux/supplierStatus';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

export default function useSupplierStatus() {
    const dispatch = useDispatch();
    const reduxState = useSelector(state => state.supplierStatus);
    const items = selectors.selectAll(reduxState);
    const loading = reduxState.loading;

    useEffect(() => {
        dispatch(getAll());
    }, [dispatch]);

    const save = useCallback((item) => {
        if (item.account_status_name.length === 0) {
            toast.error("Please fill in status name.");
            return;
        }
        const updateCall = async () => {
            if (item.account_status_id) {
                await dispatch(updateItem({ id: item.account_status_id, ...item }));
            } else {
                await dispatch(addItem({ ...item, company_type: 'SUPPLIER' }));
            }
            toast.success("Saved successfully");
        };

        updateCall();
    }, [dispatch]);

    const remove = useCallback((item) => {
        const deleteCall = async () => {
            await dispatch(deleteItem(item));
            toast.success("Deleted successfully");
        };

        deleteCall();
    }, [dispatch]);

    return [
        items,
        loading,
        save,
        remove
    ];
};
